import { render, staticRenderFns } from "./Step1Ans.vue?vue&type=template&id=6b791bcf"
import script from "./Step1Ans.vue?vue&type=script&lang=js"
export * from "./Step1Ans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports